@let organizationLabel = organizationLabelSg();
@let isSubmitting =
  standardUsersEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-add-standard-user-modal">
    <atn-ds-widget title="User Organizations Assignments">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-add-standard-user-modal__content">
        <atn-ds-select-single
          label="User"
          [items]="userSelectItemsSg()"
          [value]="selectedUserIdSg()"
          [required]="true"
          (valueChange)="selectedUserChangedHandler($event)"
          placeholder="Select user"
        />

        <atn-ds-select-multiple
          [label]="organizationLabel"
          [config]="{
            overlay: {
              minSearchCharacters: 1,
              hasSearch: true,
            },
          }"
          [items]="organizationOptionsSg()"
          [value]="selectedOrganizationIdsSg()"
          (valueChange)="selectedOrganizationsChangedHandler($event)"
          placeholder="Select {{ organizationLabel.toLowerCase() }}"
        />
      </div>

      <div
        class="atn-space-add-standard-user-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!canConfirmSg()"
          [loading]="isSubmitting"
          (click)="saveClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
